import { render, staticRenderFns } from "./promptOption.vue?vue&type=template&id=c6000482&scoped=true&"
import script from "./promptOption.vue?vue&type=script&lang=ts&"
export * from "./promptOption.vue?vue&type=script&lang=ts&"
import style0 from "./promptOption.vue?vue&type=style&index=0&id=c6000482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6000482",
  null
  
)

export default component.exports